import React, { useState } from 'react';
import Policy from "./Policy";

function LazadaNote() {
    const [isOpen, setIsOpen] = useState(false);
    const onOpen = () => {
        setIsOpen((prev) => !prev);
    };
    return (
        <div className="text-sm w-full cursor-pointer" onClick={onOpen}>
            <h4 className="text-center bg-amber-200 p-1">
                <p>
                    Bạn sẽ không được hoàn tiền nếu không tuân thủ
                    <br />
                    <span class="font-bold underline mx-1">
                        Điều kiện & Điều khoản
                    </span>{" "}
                    của chúng tôi.
                </p>
            </h4>
            {isOpen && <Policy fromColorBg={'from-blue-600'} toColorBg={'to-blue-800'} />}
        </div>
    );
}

export default LazadaNote;
